const domainWithoutWWWRegex = /http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g

export const replaceWWW = (domain: string): string => domain.replace(domainWithoutWWWRegex, '')
